/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AaiSchema } from '../../asyncapi/models/AaiSchema';
import { Aai20Document } from '../../asyncapi/v2/models/Aai20Document';
import { Aai20NodeFactory } from '../../asyncapi/v2/models/Aai20NodeFactory';
import { ModelUtils } from '../util/ModelUtils';
import { Document } from '../../core/models/Document';
import { DeleteSchemaDefinitionCommand } from './DeleteSchemaDefinitionCommand';
import { AaiComponents } from '../../asyncapi/models/AaiComponents';
import { Node } from '../../core/models/Node';

/**
 * @author c.desc2@gmail.com
 * @extends DeleteSchemaDefinitionCommand
 * @class
 */
export class DeleteSchemaDefinitionCommand_Aai20 extends DeleteSchemaDefinitionCommand {
    public constructor(definitionName? : any) {
        if(((typeof definitionName === 'string') || definitionName === null)) {
            let __args = arguments;
            super(definitionName);
        } else if(definitionName === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }

    /**
     * @see DeleteSchemaDefinitionCommand#doDeleteSchemaDefinition(Document)
     * @param {Document} document
     * @return {*}
     */
    doDeleteSchemaDefinition(document : Document) : any {
        let aai20Document : Aai20Document = <Aai20Document>document;
        if(ModelUtils.isDefined(aai20Document.components)) {
            let oldDef : AaiSchema = aai20Document.components.removeSchemaDefinition(this._definitionName);
            return Library.writeNode(oldDef);
        }
        return null;
    }

    /**
     * @see DeleteSchemaDefinitionCommand#doRestoreSchemaDefinition(Document, Object)
     * @param {Document} document
     * @param {*} oldDefinition
     */
    doRestoreSchemaDefinition(document : Document, oldDefinition : any) {
        let aai20Document : Aai20Document = <Aai20Document>document;
        if(ModelUtils.isDefined(aai20Document.components)) {
            let schemaDef : AaiSchema = new Aai20NodeFactory().createSchemaDefinition(aai20Document.components, this._definitionName);
            Library.readNode(oldDefinition, schemaDef);
            aai20Document.components.addSchemaDefinition(this._definitionName, schemaDef);
        }
    }
}
DeleteSchemaDefinitionCommand_Aai20["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteSchemaDefinitionCommand_Aai20";
DeleteSchemaDefinitionCommand_Aai20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




